import { render, staticRenderFns } from "./CustomerUserConnectedCustomersCard.vue?vue&type=template&id=72160368"
import script from "./CustomerUserConnectedCustomersCard.vue?vue&type=script&lang=ts"
export * from "./CustomerUserConnectedCustomersCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports